// extracted by css-extract-rspack-plugin
export default {"cls1":"Placeholder-cls1_cWD","cls2":"Placeholder-cls2_VdJ Placeholder-cls1_cWD","small":"Placeholder-small_YNR","swipe":"Placeholder-swipe_BND"};